import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

const PUBLIC_GRAPHQL_OPERATIONS = [
  'PublicRatingQuestions',
  'PublicCreateManyGymRatings',
  'PublicContractDetails',
  'GenerateContract',
];

@Injectable()
export class AuthInterceptor extends AuthHttpInterceptor {
  override intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url === environment.HTTP_GRAPHQL_ENDPOINT) {
      if (
        req.body instanceof Object &&
        'operationName' in req.body &&
        PUBLIC_GRAPHQL_OPERATIONS.includes(req.body.operationName as string)
      ) {
        return next.handle(req);
      }
      return super.intercept(req, next);
    }

    return super.intercept(req, next);
  }
}
